import { Component, input, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { UserCatalogEntity } from '@miq/catalog';
import { Group } from '../group';
import { MiqCheckboxMultigroupParent } from '../miq-checkbox-multigroup-parent';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-checkboxgroup',
  templateUrl: './checkboxgroup.component.html',
  styleUrl: './checkboxgroup.component.scss',
  imports: [
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatCheckbox,
    MatIcon,
    FormsModule
],
})
export class CheckboxgroupComponent implements OnInit {
  group = input<Group>();
  parentComponent = input.required<MiqCheckboxMultigroupParent>();
  allComplete = signal(false);
  ngOnInit() {
    this.allComplete.set(this.group().NestedGroup != null && this.group().NestedGroup.every(t => t.completed));
    if (
      this.group().completed &&
      ![UserCatalogEntity.deleteRecordGroup, UserCatalogEntity.entityLevelAccess].includes(this.group().key)
    ) {
      this.allComplete.set(this.group().completed);
      if (this.group().NestedGroup) {
        this.group().NestedGroup?.forEach(t => (t.completed = this.group().completed));
      }
    }
  }
  updateAllComplete(): void {
    this.allComplete.set(this.group().NestedGroup != null && this.group().NestedGroup.every(t => t.completed));
    this.group().completed =
      this.allComplete() || (this.group().NestedGroup != null && this.group().NestedGroup.some(t => t.completed));
  }
  someComplete(): boolean {
    if (this.group().NestedGroup == null) {
      return false;
    }
    return this.group().NestedGroup.filter(t => t.completed).length > 0 && !this.allComplete();
  }
  setAll(completed: boolean): void {
    this.allComplete.set(completed);
    this.group().completed = this.allComplete();
    if (this.group().NestedGroup == null) {
      return;
    }
    this.group().NestedGroup.forEach(t => (t.completed = completed));
  }
  getText() {
    this.parentComponent().onChange(this.parentComponent().getSelectedGroupPayload());
    this.parentComponent().onTouch();
    this.parentComponent().getGroupCount();
  }
}
